<template>
  <div>
    <div v-if="isOoredoo">
      <div v-if="isOoredooShamel">
        Congratulations! You have successfully subcribed to 2 months of Telly for free!
        After your free trial period of 2 months, you will be charged  KD 3/month.
      </div>

      <div v-else>
        Congratulations! You have successfully subcribed to Telly.
      </div>
    </div>

    <div v-else>
      Thank you for subscribing to Telly’s unlimited catalog of on-demand movies and TV shows.
      Happy Streaming!
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionPaymentSuccess',
  data: () => ({
    isOoredoo: false,
    isOoredooShamel: false,
  }),
  created() {
    this.isOoredoo = this.$route.query.carrier === 'ooredoo';
    this.isOoredooShamel = this.$route.query.shamel;
  },
};
</script>
